import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { WithContractGuard } from '@ibk/beneficios';
import { TranslationProvider } from '@ibk/shared-translation';
import { Loading } from '@ibk/shared-ui';
import { useEmissorFlow } from '../../hooks/useEmissorFlow';
import { beneficiosTranslations } from '../../translations';
import { EmissorPaymentContent } from '../EmissorPaymentPage';
import { PaymentContent } from './components/PaymentContent';
function RechargePaymentPageContent() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { isEmissorFlow, isLoading: isEmissorFlowLoading } = useEmissorFlow();
    if (!id) {
        navigate('/beneficios', { replace: true });
        return null;
    }
    if (isEmissorFlowLoading) {
        return _jsx(Loading, { fullScreen: true });
    }
    if (isEmissorFlow) {
        return _jsx(EmissorPaymentContent, { orderId: id });
    }
    return _jsx(PaymentContent, { rechargeId: id });
}
export function RechargePaymentPage() {
    return (_jsx(WithContractGuard, { children: _jsx(TranslationProvider, { translations: beneficiosTranslations, children: _jsx(RechargePaymentPageContent, {}) }) }));
}
